var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { DataApiDebug } from './DataApiDebug';
export class AsyncLoad extends Component {
    constructor(isDebugEnabled = false) {
        super('AsyncLoad', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.sections = $('.async-load');
            $(window).on('scroll', () => {
                this.spy();
            });
            this.spy();
            this.success();
        });
    }
    spy() {
        this.sections.each((section) => __awaiter(this, void 0, void 0, function* () {
            if (Math.floor(section.viewportPosition().y) < $(window).height() - 200 && section.data('isLoaded') != 'true') {
                section.data('isLoaded', 'true');
                section.empty().append($.parseHTML('<div></div><div class="d-flex justify-content-center my-32"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>'));
                DataApiDebug.timer_start(`load_collapsible_content (${section.data('content')})`);
                const response = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'load_async_content',
                        'content': section.data('content'),
                        'id': section.data('id'),
                        'view_as_structure': section.data('viewAsStructure') ? section.data('viewAsStructure') : '',
                    },
                    dataType: 'html'
                });
                DataApiDebug.timer_end(`load_collapsible_content (${section.data('content')})`);
                section.empty().append(response);
            }
        }));
    }
}
